export default {
    root: {
        borderRadius: 11,
    },
    input: {
        // padding: '10px 14px',
    },
};
